import React from 'react';
import { Navbar } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import NavbarBookmarks from './NavbarBookmarks';
import NavbarUser from './NavbarUser';
import userImg from '../../../assets/img/portrait/small/profilePhoto.png';
import navigationConfig from '../../../configs/horizontalMenuConfig';
import './navbar.css';

const ThemeNavbar = (props) => {
  const colorsArr = ['primary', 'danger', 'success', 'info', 'warning', 'dark'];
  const navbarTypes = ['floating', 'static', 'sticky', 'hidden'];
  const renderMenu = (array) => {
    return array.map((item) => {
      return (
        <NavLink
          to={item.navLink}
          className="mx-2 deactiveMenuButton"
          activeClassName='mx-2 activeMenuButton'
        >
          <div className="dropdown-text">
            <span className="menu-icon align-middle mr-75">
              {item.icon}
            </span>
            <span className="menu-title align-middle">
              {item.title}
            </span>
          </div>
        </NavLink>
      )
    });
  };
  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
        <Navbar
          className={classnames(
            'header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow',
            {
              'navbar-light':
                props.navbarColor === 'default' ||
                !colorsArr.includes(props.navbarColor),
              'navbar-dark': colorsArr.includes(props.navbarColor),
              'bg-primary':
                props.navbarColor === 'primary' &&
                props.navbarType !== 'static',
              'bg-danger':
                props.navbarColor === 'danger' && props.navbarType !== 'static',
              'bg-success':
                props.navbarColor === 'success' &&
                props.navbarType !== 'static',
              'bg-info':
                props.navbarColor === 'info' && props.navbarType !== 'static',
              'bg-warning':
                props.navbarColor === 'warning' &&
                props.navbarType !== 'static',
              'bg-dark':
                props.navbarColor === 'dark' && props.navbarType !== 'static',
              'd-none': props.navbarType === 'hidden' && !props.horizontal,
              'floating-nav':
                (props.navbarType === 'floating' && !props.horizontal) ||
                (!navbarTypes.includes(props.navbarType) && !props.horizontal),
              'navbar-static-top':
                props.navbarType === 'static' && !props.horizontal,
              'fixed-top': props.navbarType === 'sticky' || props.horizontal,
              scrolling: props.horizontal && props.scrolling,
            }
          )}
        >
          <div className="navbar-wrapper">
            <div className="navbar-container content">
              <div
                className="navbar-collapse d-flex justify-content-between align-items-center"
                id="navbar-mobile"
              >
                {!props.horizontal && (<div className="bookmark-wrapper">
                  <NavbarBookmarks
                    sidebarVisibility={props.sidebarVisibility}
                    handleAppOverlay={props.handleAppOverlay}
                  />
                </div>)}
                {props.horizontal ? (
                  <>
                    <div className="logo d-flex align-items-center">
                      <NavLink to="/" className="navbar-brand">
                        {<div className="brand-logo mr-50"></div>}
                      </NavLink>
                    </div>
                    <div className="d-flex">
                      {renderMenu(navigationConfig(props.role))}
                    </div>
                  </>
                ) : null}

                <NavbarUser
                  handleAppOverlay={props.handleAppOverlay}
                  changeCurrentLang={props.changeCurrentLang}
                  userName="Bolt Insight User"
                  userImg={userImg}
                />
              </div>
            </div>
          </div>
        </Navbar>
      
    </React.Fragment>
  );
};

export default ThemeNavbar;
